<template>
  <div class="w w1200">
    <!-- 面包屑导航 -->
    <el-page-header class="page-nav" @back="$router.back()" content="文章详情">
    </el-page-header>
    <div class="article">
      <div class="article-title">{{article.articleTitle}}</div>
      <div class="article-data">
        <span>{{type == '1' ? '资讯中心' : '帮助中心'}}</span>
        <span class="dot"></span>
        <span>{{article.createTime | formatTime('yyyy-MM-dd')}}</span>
      </div>
      <div class="content" v-html="article.articleContent"></div>
    </div>
  </div>
</template>
<script>
import {articleDetail} from '../../api/xunyou'

export default {
  name: 'articleDetail',
  data() {
    return {
      type: 1,
      currentArticleId: null,
      article: ''
    }
  },
  created() {
    this.currentArticleId = this.$route.query.articleId;
    this.type = this.$route.query.type;
    this.getArticleDetail();
  },
  methods: {
    getArticleDetail () {
      let loading = this.$loading();
      articleDetail({ articleId: this.currentArticleId })
        .then(res => {
          console.log('文章详情：', res);
          if (res.code === 0) {
            this.article = res.data;
          }
        })
        .catch(err => {
          console.error('错误：', err);
        })
        .finally(() => {
          loading.close();
        });
    },
  }
};
</script>

<style scoped lang="less">
.page-nav{
  margin: 15px 0;
}
.article{
  background-color: #fff;
  padding: 20px;
  .article-title{
    font-size: 18px;
    font-weight: 500;
    text-align: center;
  }
  .article-data{
    text-align: center;
    color: #888888;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 30px;
    .dot{
      margin: 0 10px;
      width: 5px;
      height: 5px;
      background-color: #888;
      border-radius: 50%;
    }

  }
}
</style>







// WEBPACK FOOTER //
// src/views/serviceArticle/articleDetail.vue